import { Dialog, FlatButton } from 'material-ui';
import React from 'react';

export default function MergeErrorDialog({ 
    isMergeErrorOpened, handleMergeErrorOpened, errorAltNames, handleBypassError,
}) {
    const actions = [
        <FlatButton
            label="Cancel"
            primary
            onClick={handleMergeErrorOpened}
        />,
        <FlatButton
            label="Submit"
            primary
            keyboardFocused
            onClick={handleBypassError}
        />,
    ];

    return (
        <Dialog
            title="Approve required"
            actions={actions}
            modal={false}
            open={isMergeErrorOpened}
            onRequestClose={handleMergeErrorOpened}
        >
            <p>
                To merge specified regoins, alt name <b>'{errorAltNames.join(', ')}'</b> has to be removed from destination area
                and then areas will be merged. Do you want to proceed?
            </p>
        </Dialog>
    );
}



// WEBPACK FOOTER //
// ./app/components/Regions/Merging/MergeErrorDialog.jsx